// @flow

import _ from 'lodash';
import ko from 'knockout';
import $ from 'jquery';

ko.bindingHandlers.preventDefault = {
	init: function (element, valueAccessor) {
		const events = ko.unwrap(valueAccessor());

		_.each(events, event => {
			$(element).on(`${event}.ko.binding.preventDefault`, (e: Event) => e.preventDefault());
		});
	},
};

function defineShortcutBinding (event) {
	ko.bindingHandlers[`${event}PreventDefault`] = {
		init: function (...args) {
			const [
				element,
				/* valueAccessor */,
				/* allBindings */,
				/*viewModel*/,
				bindingContext,
			] = args;

			ko.applyBindingAccessorsToNode(element, {
				preventDefault: () => [event],
			}, bindingContext);
		},
	};
}

defineShortcutBinding('click');
defineShortcutBinding('submit');
